export default __webpack_public_path__ + "static/media/huella.a2a267e5.png";